import { Button, Checkbox, FormControlLabel, Typography } from "@mui/material";
import NextAction from "../../utils/NextAction";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Latex from "react-latex-next";

function createData(
  vertex: string,
  dist?: number,
  estimatedDist?: number,
  visited?: boolean,
  previous?: string
) {
  return { vertex, dist, estimatedDist, visited: visited, previous };
}

const rows = [
  [
    createData("A", null, 3.6, false, null),
    createData("B", null, 2, false, null),
    createData("C", null, 3.16, false, null),
    createData("D", null, 2.23, false, null),
    createData("E", null, 1.41, false, null),
    createData("F", null, 1, false, null),
    createData("G", null, 3, false, null),
    createData("H", null, 0, false, null),
    createData("I", null, 3.16, false, null),
    createData("J", null, 2.23, false, null),
  ],
  [
    createData("A", 0, 3.6, false, null),
    createData("B", null, 2, false, null),
    createData("C", null, 3.16, false, null),
    createData("D", null, 2.23, false, null),
    createData("E", null, 1.41, false, null),
    createData("F", null, 1, false, null),
    createData("G", null, 3, false, null),
    createData("H", null, 0, false, null),
    createData("I", null, 3.16, false, null),
    createData("J", null, 2.23, false, null),
  ],
  [
    createData("A", 0, 3.6, true, null),
    createData("B", null, 2, false, null),
    createData("C", 1, 3.16, false, "A"),
    createData("D", null, 2.23, false, null),
    createData("E", null, 1.41, false, null),
    createData("F", null, 1, false, null),
    createData("G", null, 3, false, null),
    createData("H", null, 0, false, null),
    createData("I", null, 3.16, false, null),
    createData("J", null, 2.23, false, null),
  ],
  [
    createData("A", 0, 3.6, true, null),
    createData("B", null, 2, false, null),
    createData("C", 1, 3.16, true, "A"),
    createData("D", 2, 2.23, false, "C"),
    createData("E", null, 1.41, false, null),
    createData("F", null, 1, false, null),
    createData("G", null, 3, false, null),
    createData("H", null, 0, false, null),
    createData("I", null, 3.16, false, null),
    createData("J", null, 2.23, false, null),
  ],
  [
    createData("A", 0, 3.6, true, null),
    createData("B", null, 2, false, null),
    createData("C", 1, 3.16, true, "A"),
    createData("D", 2, 2.23, false, "C"),
    createData("E", null, 1.41, false, null),
    createData("F", null, 1, false, null),
    createData("G", 2, 3, false, "C"),
    createData("H", null, 0, false, null),
    createData("I", null, 3.16, false, null),
    createData("J", null, 2.23, false, null),
  ],
  [
    createData("A", 0, 3.6, true, null),
    createData("B", null, 2, false, null),
    createData("C", 1, 3.16, true, "A"),
    createData("D", 2, 2.23, true, "C"),
    createData("E", 3, 1.41, false, "D"),
    createData("F", null, 1, false, null),
    createData("G", 2, 3, false, "C"),
    createData("H", null, 0, false, null),
    createData("I", null, 3.16, false, null),
    createData("J", null, 2.23, false, null),
  ],
  [
    createData("A", 0, 3.6, true, null),
    createData("B", null, 2, false, null),
    createData("C", 1, 3.16, true, "A"),
    createData("D", 2, 2.23, true, "C"),
    createData("E", 3, 1.41, true, "D"),
    createData("F", 4, 1, false, "E"),
    createData("G", 2, 3, false, "C"),
    createData("H", null, 0, false, null),
    createData("I", null, 3.16, false, null),
    createData("J", null, 2.23, false, null),
  ],
  [
    createData("A", 0, 3.6, true, null),
    createData("B", null, 2, false, null),
    createData("C", 1, 3.16, true, "A"),
    createData("D", 2, 2.23, true, "C"),
    createData("E", 3, 1.41, true, "D"),
    createData("F", 4, 1, true, "E"),
    createData("G", 2, 3, false, "C"),
    createData("H", 5, 0, false, "F"),
    createData("I", null, 3.16, false, null),
    createData("J", null, 2.23, false, null),
  ],
  [
    createData("A", 0, 3.6, true, null),
    createData("B", null, 2, false, null),
    createData("C", 1, 3.16, true, "A"),
    createData("D", 2, 2.23, true, "C"),
    createData("E", 3, 1.41, true, "D"),
    createData("F", 4, 1, true, "E"),
    createData("G", 2, 3, true, "C"),
    createData("H", 5, 0, false, "F"),
    createData("I", 3, 3.16, false, "G"),
    createData("J", null, 2.23, false, null),
  ],
  [
    createData("A", 0, 3.6, true, null),
    createData("B", null, 2, false, null),
    createData("C", 1, 3.16, true, "A"),
    createData("D", 2, 2.23, true, "C"),
    createData("E", 3, 1.41, true, "D"),
    createData("F", 4, 1, true, "E"),
    createData("G", 2, 3, true, "C"),
    createData("H", 5, 0, true, "F"),
    createData("I", 3, 3.16, false, "G"),
    createData("J", null, 2.23, false, null),
  ],
];

const texts = [
  `Click the below button "Start Tutorial" to see step by step of A* Algorithm for Grids.`,
  "We know the distance between A and A is 0, so we can update the distance value in the table accordingly.",
  "Let's check the A node and mark 'Visited' as True. First, we update the distance between A and C. We know the distance between these two nodes is 1, so we replace infinity with 1 and label 'A' in the 'Previous Node' column.",
  "After finishing the process of checking A, we start to trace another node. We find the shortest path on the table first, which is A -> C. We label C as True in the Visited column. Because the distance between C and D is 1, we also update the shortest distance between A and D to 2.",
  "Check the distance from C to G. Update the shortest distance from A to G to 2 and label the previous node of G as C.",
  "Next, the distances between A and D and A and G are both 2. If we consider the estimated distance to H, we have choose D because  2+2.23 (D) < 2+3 (G). We label D as True in the Visited column. The only neighbors of D is E. The distance between D and E is 1, so we update the shortest distance to E to 2 + 1 = 3.",
  "Again, the total distance function of E, 3+1.41 is smaller than G, 2+3. We chosse E for the next step.",
  "F and G have the same value of distance function as 5. We choose F in alphabet order.",
  "G and H have the same value of distance function as 5. We choose G in alphabet order.",
  "Finally, H have the smallest value of distance function. We choose H for this step and label True on the Visited column. We now get the shortest from A to H which is 5!",
];

interface ContrlProps {
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
}

export default function Controls({ step, setStep }: ContrlProps) {
  return (
    <div className="controls">
      <div>
        <Typography variant="h5" style={{ paddingBottom: 20 }}>
          A* Algorithm For Grids
        </Typography>
        <Typography style={{ paddingBottom: 10, textAlign: "left" }}>
          There is a special estimated movement cost used in the A* algorithm.
          In the A* algorithm, we not only choose the shortest distance from the
          start point for the next path planning step but also use a heuristic
          estimate of the distance to the target. Here, we use the{" "}
          <b>coordinates distance</b>{" "}
          <Latex>{`$$ d = \\sqrt{(x_1-x_2)^2 + (y_1-y_2)^2}$$`}</Latex>as the
          heuristic function.
          <br />
          The main difference between A* and Dijkstra's is: in each step, we
          always choose the node{" "}
          <b>
            with the smallest value of the shortest distance from A plus the
            estimated distance to the target H
          </b>
          . In A* algorithm, you can think the distance function for each node x
          is <Latex>{`$$ f(x) = d(A, x) + e(H, x)$$`}</Latex>
          <Latex>{`$d(A, x)$`}</Latex> is the shortest distance to start A.
          <br />
          <Latex>{`$e(H, x)$`}</Latex> is the estimated coordinates distance to
          target H.
        </Typography>
        {step == 0 && (
          <Typography
            style={{
              paddingBottom: 10,
              textAlign: "left",
              whiteSpace: "pre-line",
            }}
          >
            {texts[step]}
          </Typography>
        )}
        {step != 0 && (
          <>
            <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
              Step {step}
            </Typography>
            <Typography
              sx={{ mb: 3, textAlign: "left", whiteSpace: "pre-line" }}
            >
              {texts[step]}
            </Typography>
          </>
        )}
        <TableContainer
          component={Paper}
          sx={{ mb: 2, maxWidth: 800, mr: "auto", ml: "auto" }}
        >
          <Table sx={{ maxWidth: 800 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Vertex</TableCell>
                <TableCell align="center">Shortest Distance From A</TableCell>
                <TableCell align="center">Estimated Distance to H</TableCell>
                <TableCell align="center">Visited</TableCell>
                <TableCell align="center">Previous Node</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows[step].map((row, i) => (
                <TableRow
                  key={row.vertex}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell component="th" scope="row" sx={{ fontSize: 18 }}>
                    {row.vertex}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={
                      step !== 0 && row.dist != rows[step - 1][i].dist
                        ? { color: "red", fontWeight: "bold", fontSize: 18 }
                        : { fontSize: 18 }
                    }
                  >
                    {row.dist == null ? "infinity" : row.dist}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={
                      step !== 0 &&
                      row.estimatedDist != rows[step - 1][i].estimatedDist
                        ? { color: "red", fontWeight: "bold", fontSize: 18 }
                        : { fontSize: 18 }
                    }
                  >
                    {row.estimatedDist}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={
                      step !== 0 && row.visited != rows[step - 1][i].visited
                        ? { color: "red", fontWeight: "bold", fontSize: 18 }
                        : { fontSize: 18 }
                    }
                  >
                    {row.visited ? "True" : "False"}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={
                      step !== 0 && row.previous != rows[step - 1][i].previous
                        ? { color: "red", fontWeight: "bold", fontSize: 18 }
                        : { fontSize: 18 }
                    }
                  >
                    {row.previous || "null"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {step == 0 && (
          <Button
            variant={"contained"}
            sx={{ mb: 2 }}
            onClick={() => setStep(1)}
          >
            Start Tutorial
          </Button>
        )}
        {step != 0 && (
          <>
            <Button
              variant={"contained"}
              sx={{ mb: 2, mr: 4 }}
              onClick={() => setStep(step - 1)}
            >
              Previous
            </Button>
            {step !== 9 && (
              <Button
                variant={"contained"}
                sx={{ mb: 2 }}
                onClick={() => setStep(step + 1)}
              >
                Next
              </Button>
            )}
          </>
        )}
        {step == 9 && (
          <>
            <Typography style={{ paddingBottom: 10, textAlign: "left" }}>
              Great job! You found the shortest path from A to H using the A*
              algorithm in only 9 steps! We took 13 steps with Dijkstra's
              algorithm. Also, the number of visited blocks in the A* algorithm
              is smaller than in Dijkstra's algorithm. Now you know why A* is
              faster than Dijkstra's.
            </Typography>
          </>
        )}
      </div>
    </div>
  );
}
